/**
 * created by sy 2018-09-22
 * api接口
 * */

const baseUrl = 'https://www.tianxia120.com';
// const baseUrl = 'http://localhost:6001';
// const baseUrl = 'http://192.168.0.110:8080/cat';
// const baseUrl = 'http://app-uat.tianxia120.com/cat';
export default {
  tempUrl: baseUrl,
  menu: baseUrl + '/menu/list',
  companyNews: baseUrl + '/article/list',
  companyNewsDetails: baseUrl + '/article/index',
  videoSrc: baseUrl + '/article/static',
  queryBanner: baseUrl + '/cat/advertisementManager/clientSearchAdvertisement', // 客户端查询广告内容

}



// WEBPACK FOOTER //
// ./src/api/commonUrl.js